import * as React from 'react';
import {
    Edit,
    BooleanInput,
    TabbedForm,
    AutocompleteInput,
    ReferenceInput,
    useTranslate,
} from 'react-admin';
import { Box, Typography } from '@mui/material';
import SegmentsFormToolbar from './SegmentsFormToolbar';
import { RichTextInput } from '../components/RichTextInput';

const DynamicPagesForm = () => {
    const translate = useTranslate();
    const formDefaults = {
        multiple: true,
        method: 'post',
    };
    return (
        <Edit resource="settings" redirect={false} mutationMode="pessimistic">
            <Box>
                <Typography variant="h4" padding={2}>
                    {translate('resources.settings.fieldGroups.dynamic_pages')}
                </Typography>
                <TabbedForm
                    defaultValues={formDefaults}
                    toolbar={<SegmentsFormToolbar />}
                    syncWithLocation={false}
                >
                    <TabbedForm.Tab label="resources.settings.fieldGroups.city_pages">
                        <RichTextInput
                            source="CityPages__beforeCityAdditionalList"
                            label="resources.settings.values.city_pages__before_city_additional_list"
                            fullWidth
                        />
                        <RichTextInput
                            source="CityPages__afterCityAdditionalList"
                            label="resources.settings.values.city_pages__after_city_additional_list"
                            fullWidth
                        />
                        <RichTextInput
                            source="CityPages__beforeToCityTable"
                            label="resources.settings.values.city_pages__before_to_city_table"
                            fullWidth
                        />
                        <RichTextInput
                            source="CityPages__afterToCityTable"
                            label="resources.settings.values.city_pages__after_to_city_table"
                            fullWidth
                        />
                        <RichTextInput
                            source="CityPages__beforeFromCityTable"
                            label="resources.settings.values.city_pages__before_from_city_table"
                            fullWidth
                        />
                        <RichTextInput
                            source="CityPages__afterFromCityTable"
                            label="resources.settings.values.city_pages__after_from_city_table"
                            fullWidth
                        />
                        <RichTextInput
                            source="CityPages__beforeIntercityTable"
                            label="resources.settings.values.city_pages__before_intercity_table"
                            fullWidth
                        />
                        <RichTextInput
                            source="CityPages__afterIntercityTable"
                            label="resources.settings.values.city_pages__after_intercity_table"
                            fullWidth
                        />
                        <BooleanInput
                            source="CityPages__updateCityPagesFromCityActive"
                            label="resources.settings.values.city_pages__update_city_pages_from_city_active"
                            fullWidth
                        />
                    </TabbedForm.Tab>
                    <TabbedForm.Tab label="resources.settings.fieldGroups.city_items_pages">
                        <BooleanInput
                            source="CityItemsPages__from_pages_active"
                            label="resources.settings.values.city_items_pages__from_pages_active"
                            fullWidth
                        />
                    </TabbedForm.Tab>
                    <TabbedForm.Tab label="resources.settings.fieldGroups.page_replacement">
                        <ReferenceInput
                            source="Logistics__bidsPageId"
                            reference="pages"
                            label="resources.settings.values.logistics__bids_page_id"
                        >
                            <AutocompleteInput optionText="title" fullWidth />
                        </ReferenceInput>
                        <ReferenceInput
                            source="Logistics__tracertPageId"
                            reference="pages"
                            label="resources.settings.values.logistics__tracert_page_id"
                        >
                            <AutocompleteInput optionText="title" fullWidth />
                        </ReferenceInput>
                        <ReferenceInput
                            source="Logistics__calculatePageId"
                            reference="pages"
                            label="resources.settings.values.logistics__calculate_page_id"
                        >
                            <AutocompleteInput optionText="title" fullWidth />
                        </ReferenceInput>
                        <ReferenceInput
                            source="Logistics__blogPageId"
                            reference="pages"
                            label="resources.settings.values.logistics__blog_page_id"
                        >
                            <AutocompleteInput optionText="title" fullWidth />
                        </ReferenceInput>
                        <ReferenceInput
                            source="Logistics__vacanciesPageId"
                            reference="pages"
                            label="resources.settings.values.logistics__vacancies_page_id"
                        >
                            <AutocompleteInput optionText="title" fullWidth />
                        </ReferenceInput>
                    </TabbedForm.Tab>
                </TabbedForm>
            </Box>
        </Edit>
    );
};

export default DynamicPagesForm;
